import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type UserStudentProjectsPermissionCodes =
  | 'CAN_ASSIGN_STUDENT_TO_PROJECT'
  | 'CAN_UNASSIGN_STUDENT_FROM_PROJECT';

interface FetchProps {
  userId: number;
  projectId: number;
  studentId: number;
}

const useStudentProjectsPermissions = getPermissionsHook<
  UserStudentProjectsPermissionCodes,
  FetchProps
>({
  entityName: 'userStudentProjectsPermissions',
  fetch: ({ userId, projectId, studentId }: FetchProps) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .students.id(studentId)
      .projects.id(projectId)
      .permissions.find(),
});

export default useStudentProjectsPermissions;
